module.exports = new __parcel__URL__("release.e083327a.svg").toString();